import React, {Component} from "react";
import {Chip} from "@mui/material";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {error_manager} from "../../../helper/error_manager";
import {updateTileViewerState} from "../../../redux_actions/morpheus.setting.action";
import {store} from "../../../helper/store";

class BaseLayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			drew: false,
		};
	}

	componentDidMount() {
		this.init();
		this.layer.get("drew") ? this.setDrawCompleteState() :
			this.draw().then(this.onDrawComplete)
				.catch(error => error_manager(`Failed to draw ${this.label} layer`, error));
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.textColor !== this.props.textColor) {
			this.draw();
		}
		if (prevProps.textSize !== this.props.textSize || prevProps.rescanThreshValue1 !== this.props.rescanThreshValue1
			|| prevProps.rescanThreshValue2 !== this.props.rescanThreshValue2) {
			this.props.map.removeLayer(this.layer);
			this.init();
			this.draw().then(this.onDrawComplete);
		}
		if (this.props.tileViewerState['tiltFocusPoints'] &&
			((prevProps.z <= 3 && this.props.z > 3) || (prevProps.z > 3 && this.props.z <= 3))) {
			if (this.layer.get('id') === 'tiltFocusPoints')
				this.layer.setVisible(this.props.z <= 3);
			if (this.layer.get('id') === 'tiltFocusWithDicy')
				this.layer.setVisible(this.props.z > 3);
		}
	}

	draw = () => new Promise((resolve, reject) => {
		resolve();
	});

	onDrawComplete = () => {
		this.props.map.addLayer(this.layer);
		this.layer.set("drew", true);
		this.setDrawCompleteState();
	}

	setDrawCompleteState = () =>
		this.setState({visible: this.layer.getVisible(), drew: true});

	init = () =>
		this.layer = this.props.map.getLayers().getArray().find(layer => layer.get("id") === this.id) ||
			this.createLayer();

	createLayer = () => new VectorLayer({
		id: this.id,
		source: this.getSource(),
		extent: this.props.map.getView().getProjection().getExtent(),
		visible: this.defaultVisible || false,
		zIndex: 1000000,
		style: this.style,
		drew: false,
		onFeatureSelect: this.onFeatureSelect,
		onFeatureHover: this.onFeatureHover,
	});

	getSource = () => new VectorSource({
		wrapX: false,
	});

	toggleVisible = () => {
		let tileViewState = this.props.tileViewerState;
		tileViewState[this.id] = !this.state.visible;
		store.dispatch(updateTileViewerState(tileViewState));
		this.setState({visible: tileViewState[this.id]}, this.onToggleVisible);
	}

	onToggleVisible = () => this.layer.setVisible(this.state.visible);

	render() {
		return <Chip label={this.label}
					 key={this.id}
					 size={"small"}
					 disabled={!(this.props.tileMapEnable || !this.state.drew)}
					 onClick={this.toggleVisible}
					 sx={{width: "100%", borderRadius: 0}}
					 color={this.state.visible ? "secondary" : "primary"}/>
	}
}

export default BaseLayer;
